import { initCounters } from '~/modules/post/utils'

/**
 *
 */
export default function getCounters(posts = []) {
  const counters = initCounters()

  posts.forEach(({ totalComments, totalPendingComments, labelsCount }) => {
    counters.totalComments += totalComments
    counters.totalPendingComments += totalPendingComments

    // @ts-expect-error TS(2339) FIXME: Property 'forEach' does not exist on type 'never'.
    labelsCount.forEach(({ label, count }) => {
      // @ts-expect-error TS(2339) FIXME: Property 'label' does not exist on type 'never'.
      const counter = counters.labels.find((el) => el.label === label)
      if (counter) {
        // @ts-expect-error TS(2339) FIXME: Property 'count' does not exist on type 'never'.
        counter.count += count
      }
    })
  })

  return counters
}
